interface AppData {
  appName?: string
  deepLink?: string
  appStoreUrl?: string
}

type OS = 'ANDROID' | 'iOS'

const navigateToAndroid = (data: AppData): boolean => {
  try {
    if (data.appName) {
      window.location.replace(data.appName)
    }
    if (data.deepLink) {
      setTimeout(() => {
        if (data.deepLink) {
          window.location.replace(data.deepLink)
        }
      }, 500)
    }
    return true
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('ERROR from navigateToAndroid: ', e)
    return false
  }
}

const navigateToiOS = (data: AppData): boolean => {
  const { appStoreUrl } = data
  if (appStoreUrl) {
    window.location.replace(appStoreUrl)
  }
  return true
}

const navigateTo: Record<OS, (data: AppData) => boolean> = {
  ANDROID: navigateToAndroid,
  iOS: navigateToiOS,
}

const navigateToTheApp = ({
  deviceOS,
  data = {},
}: {
  deviceOS: OS
  data?: AppData
}): boolean => {
  return navigateTo[deviceOS] && Object.keys(data).length
    ? navigateTo[deviceOS](data)
    : false
}

export default navigateToTheApp
